// extracted by mini-css-extract-plugin
module.exports = {"input":"styles__input___GPhF-","select":"styles__select___hSFtk styles__input___GPhF-"};